/**
 * Single-fire teardown guard for proxied calls (BI-982).
 *
 * A proxied call can be torn down from several directions that race: the local
 * hangup (endProxiedCall), the start-error path, and the server close frame —
 * and releasing resources itself emits a close frame that echoes back into the
 * close handler. Exactly one of these must "win" and run teardown; the rest
 * (including the echo) must no-op.
 *
 * `claimTeardownOnce` is a compare-and-swap over a boolean ref: the first caller
 * flips it false and gets `true`; everyone after gets `false`. Pulled out of the
 * component as a pure function so the de-dup contract is unit-tested and a future
 * refactor can't silently reintroduce double-teardown. Safe without locking
 * because JS callbacks run to completion on a single thread.
 */
export function claimTeardownOnce(activeFlag: { current: boolean }): boolean {
  if (!activeFlag.current) {
    return false;
  }
  activeFlag.current = false;
  return true;
}
